import type { MaybeRefOrGetter, Ref } from 'vue';

import { toValue, watch } from 'vue';

export interface UseSearchSuggestDialogScrollLockOptions {
	/** When false, body scroll is not locked (e.g. page is already fixed fullscreen). */
	enabled?: MaybeRefOrGetter<boolean>;
}

/**
 * Scroll lock do body ao abrir o modal (SearchSuggestDialog e variantes).
 * Só executa no client; no server retorna API no-op.
 */
export function useSearchSuggestDialogScrollLock(
	isOpen: Ref<boolean>,
	options?: UseSearchSuggestDialogScrollLockOptions
) {
	if (!import.meta.client) {
		return { preventBodyScroll: () => {}, restoreBodyScroll: () => {} };
	}

	let savedScrollPosition = 0;
	let originalHtmlOverflow = '';

	function isLockEnabled(): boolean {
		return toValue(options?.enabled ?? true);
	}

	function preventBodyScroll() {
		savedScrollPosition = window.scrollY;
		originalHtmlOverflow = document.documentElement.style.overflow;
		document.documentElement.style.overflow = 'hidden';
		document.body.classList.add('scroll-locked');
		document.body.style.top = `-${savedScrollPosition}px`;
	}

	function restoreBodyScroll() {
		document.documentElement.style.overflow = originalHtmlOverflow;
		document.body.classList.remove('scroll-locked');
		document.body.style.removeProperty('position');
		document.body.style.removeProperty('top');
		document.body.style.removeProperty('width');
		document.body.style.overflow = '';
		document.body.style.height = '';
		document.body.style.touchAction = '';
		requestAnimationFrame(() => {
			window.scrollTo(0, savedScrollPosition);
		});
	}

	watch(isOpen, newValue => {
		if (!isLockEnabled()) return;
		if (newValue) {
			preventBodyScroll();
		} else {
			restoreBodyScroll();
		}
	});

	return { preventBodyScroll, restoreBodyScroll };
}
